import { createToken } from './checkout/csrf';
(() => {
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (window.App.isIosView) return;
        $('.question-button').show();
        $('.arrow-up').show();
        $('.question-button, .question__close-question-block').click(function () {
            if ($('.arrow-up').hasClass('active')) {
                // Hide question form
                $('.arrow-up').removeClass('active');
                $('.question').fadeOut(500);
                setTimeout(function () {
                    $('#question__form--post-error').hide();
                    $('.question__form-block').show();
                    $('.question__thank-you').hide();
                }, 600);
            } else {
                // Show question form
                $('.question').fadeIn(600);
                $('.arrow-up').addClass('active');
            }
        });

        $('#question__form--js').submit(function (e) {
            e.preventDefault();
            let browser_info = navigator.sayswho + ' ' + navigator.platform;

            if (validateForm()) {
                $('.question__submit').prop('disabled', true);
                $('.question__submit').html(
                    '<img class="glyphicon-spin spin-icon-hs" src="https://secure.iphonephotographyschool.com/images/global/spinner-circle.png" alt="">',
                );

                createToken('support-beacon', '.question', window.App.sessionId)
                    .then((csrf_fields) => {
                        let requestData = Object.assign(
                            {},
                            {
                                _token: $('#question__form--js > input[name=_token]').val(),
                                name: $('#question__form--js > input[name=name]').val(),
                                email: $('#question__form--js > input[name=email]').val(),
                                question: $('#question__form--js > textarea[name=question]').val(),
                                product: window.location.href,
                                browser_info: browser_info,
                                currency: window.App.currency || window.support_currency,
                                original_url: window.App.originalUrl,
                                device_data: window.navigator.sayswho + ' ' + window.navigator.platform,
                                ref: window.App.referer,
                            },
                            csrf_fields,
                        );

                        $.post(server_address + '/api/support-beacon', requestData)
                            .done(function (data) {
                                //TODO: when we start denying csrf check we have to check response here and act accordingly

                                $('#question__form--post-error').hide();
                                $('.question__form-block').hide();
                                $('.question__thank-you').show();

                                // Set form back to starting state
                                $('#question__form--js > input[name=name]').val('');
                                $('#question__form--js > input[name=email]').val('');
                                $('#question__form--js > textarea[name=question]').val('');
                                resetSubmitButton();

                                // Prevent FB Pixel events from executing if cookies are blocked
                                if (typeof fbq === 'function') {
                                    try {
                                        fbq('track', 'Contact');
                                    } catch (err) {
                                        console.log('fbq not set up');
                                        logger.captureException(err);
                                    }
                                }
                            })
                            .fail(function (xhr) {
                                switch (xhr.status) {
                                    // Handles failed server-side validation, i.e. email DNS check.
                                    case 422:
                                        if (xhr.responseJSON.errors.name != undefined) {
                                            $('#question__form--name-error').show();
                                        }
                                        if (xhr.responseJSON.errors.email != undefined) {
                                            $('#question__form--email-error').show();
                                        }
                                        if (xhr.responseJSON.errors.question != undefined) {
                                            $('#question__form--question-error').show();
                                        }
                                        break;
                                    default:
                                        $('#question__form--post-error').show();
                                }

                                resetSubmitButton();
                            });
                    })
                    .catch((csrf_error) => {
                        resetSubmitButton();
                        $('#question__form--post-error').show();
                        logger.captureException(csrf_error);
                    });
            }
        });

        $(
            '#question__form--js > input[name=name],' +
                '#question__form--js > input[name=email],' +
                ' #question__form--js > textarea[name=question]',
        ).on('input', function () {
            $(this).removeClass('error');
        });
    }
})();

window.floatingSalesButtonVisible = function () {
    // Check if floating by button exists in DOM. If so change css for question form
    if ($('.floating-buy')[0]) {
        $('.question-button, .question, .arrow-up').addClass('floating-buy-button-active');
    }
};

function validateForm() {
    var name = $('#question__form--js > input[name=name]');
    var email = $('#question__form--js > input[name=email]');
    var textarea = $('#question__form--js > textarea[name=question]');

    var wrong_count = 0;

    if (name.val() === null || name.val() === '') {
        name.addClass('error');
        $('#question__form--name-error').show();
        wrong_count += 1;
    } else {
        name.removeClass('error');
        $('#question__form--name-error').hide();
    }

    if (!validateEmail(email.val())) {
        email.addClass('error');
        $('#question__form--email-error').show();
        wrong_count += 1;
    } else {
        email.removeClass('error');
        $('#question__form--email-error').hide();
    }

    if (textarea.val() === null || textarea.val() === '') {
        textarea.addClass('error');
        $('#question__form--question-error').show();
        wrong_count += 1;
    } else {
        textarea.removeClass('error');
        $('#question__form--question-error').hide();
    }
    if (wrong_count === 0) {
        return true;
    } else {
        return false;
    }
}

function validateEmail(email) {
    var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).trim().toLowerCase());
}

function resetSubmitButton() {
    $('.question__submit').prop('disabled', false);
    $('.question__submit').html('Send');
}
